import { createSelector } from 'reselect';
import { HVAC_GROUP_AREAS, HVAC_GROUP_LIST } from 'src/modules/hvac/constants/group';
import { HVAC_VERSION_LIST } from 'src/modules/hvac/constants/version';
import { getHvacAssesmentFormData } from 'src/modules/hvac/selectors/getHvacAssesmentFormData';
import { HvacNotification } from 'src/modules/hvac/types/HvacNotification';

export const getHvacResultsInsufficientInputs = createSelector([
  getHvacAssesmentFormData,
], (formData): ReadonlyArray<HvacNotification> => {
  const result: HvacNotification[] = [];

  for (const groupKey of HVAC_GROUP_LIST) {
    for (const [groupIndex, groupData] of formData.groups[groupKey].entries()) {
      for (const areaKey of HVAC_GROUP_AREAS[groupKey]) {
        if (!formData.areas[areaKey].enabled) {
          continue;
        }

        for (const section of groupData.areas[areaKey].sections) {
          if (!section.enabled) {
            continue;
          }
          if (!section.config.has_impact) {
            continue;
          }

          for (const version of HVAC_VERSION_LIST) {
            const answer = section.answer[version].option;
            if (answer === null) {
              result.push({
                path: `${groupKey}.${groupIndex}.${areaKey}.${section.config.id}.${version}`,
                area: areaKey,
                group: {
                  group: groupKey,
                  index: groupIndex,
                  title: groupData.title,
                },
                section: section.config,
                version: version,
              });
            }
          }
        }
      }
    }
  }

  return result;
});
